import { render, staticRenderFns } from "./qa-tips.vue?vue&type=template&id=f3911494&scoped=true&"
import script from "./qa-tips.vue?vue&type=script&lang=ts&"
export * from "./qa-tips.vue?vue&type=script&lang=ts&"
import style0 from "./qa-tips.vue?vue&type=style&index=0&id=f3911494&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3911494",
  null
  
)

export default component.exports